import { render, staticRenderFns } from "./FavouriteActivity.vue?vue&type=template&id=a4c70c36&scoped=true&"
import script from "./FavouriteActivity.vue?vue&type=script&lang=js&"
export * from "./FavouriteActivity.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteActivity.vue?vue&type=style&index=0&id=a4c70c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c70c36",
  null
  
)

export default component.exports